import { useTranslation } from 'react-i18next';

import { ICompanySettings } from 'auth/types';
import { TotalPrice } from 'core/elements';
import { QuoteType } from 'quotes/enums';
import { IQuoteVersionData } from 'quotes/types';

import { TotalFreight } from './Freight';
import { ITotalPricing } from './types';

interface IProps {
  totals: ITotalPricing;
  quoteVersionData: IQuoteVersionData;
  freightSettings?: Pick<ICompanySettings, 'defaultFreightPercentage' | 'minimumFreightCharge'>;
  classNames?: string;
  freightEnabled: boolean;
  isFreightEditable?: boolean;
  quoteType: QuoteType;
}

export const TotalPricing = ({
  totals,
  quoteVersionData,
  freightSettings = {},
  classNames = '',
  freightEnabled = false,
  isFreightEditable = false,
  quoteType = QuoteType.CUSTOMER,
}: IProps) => {
  const { t } = useTranslation();

  const priceLabel = QuoteType.CUSTOMER === quoteType ? t('labelPrice') : t('labelCost');

  return (
    <>
      {QuoteType.CUSTOMER === quoteType && (
        <TotalPrice label={t('labelCost')} value={totals.cost} options={{ classNames }} />
      )}

      <TotalPrice label={priceLabel} value={totals.price} options={{ classNames }} />

      {QuoteType.CUSTOMER === quoteType && (
        <TotalPrice
          label={t('labelMargin')}
          value={totals.margin}
          options={{ classNames, isPercentage: true }}
        />
      )}

      {freightEnabled && (
        <TotalFreight
          quoteVersionData={quoteVersionData}
          freightSettings={freightSettings}
          partsTotal={totals.price}
          classNames={classNames}
          isEditable={isFreightEditable}
        />
      )}

      <TotalPrice label={t('labelTotal')} value={totals.total} options={{ classNames }} />
    </>
  );
};
